<template>
	<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M4 7V5a1 1 0 011-1h2M17 4h2a1 1 0 011 1v2M20 17v2a1 1 0 01-1 1h-2M7 20H5a1 1 0 01-1-1v-2"
			stroke="currentColor"
			stroke-width="2.2"
			stroke-linecap="round"
		></path>
		<path d="M7 12h10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"></path>
	</svg>
</template>
